import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useLocation } from 'react-router-dom';
import AcademyPathway from './AcademyPathway';

const PORTAL_ID = 'aox-academy-pathway-stage';

const AcademyPathwayPortal = () => {
  const location = useLocation();
  const [mountNode, setMountNode] = useState(null);

  useEffect(() => {
    if (location.pathname !== '/academy') {
      setMountNode(null);
      document.getElementById(PORTAL_ID)?.remove();
      return undefined;
    }

    let cancelled = false;
    let timer = null;
    let tries = 0;

    const mountPathway = () => {
      if (cancelled) return;

      const sections = Array.from(document.querySelectorAll('main section'));
      const trainingSection = sections.find((section) =>
        section.textContent?.includes('Πρόγραμμα Προπονήσεων')
      );

      if (trainingSection?.parentNode) {
        let node = document.getElementById(PORTAL_ID);
        if (!node) {
          node = document.createElement('div');
          node.id = PORTAL_ID;
          node.setAttribute('data-academy-pathway-portal', 'true');
          trainingSection.parentNode.insertBefore(node, trainingSection);
        }
        setMountNode(node);
        return;
      }

      tries += 1;
      if (tries < 30) timer = window.setTimeout(mountPathway, 100);
    };

    mountPathway();

    return () => {
      cancelled = true;
      if (timer) window.clearTimeout(timer);
      setMountNode(null);
      document.getElementById(PORTAL_ID)?.remove();
    };
  }, [location.pathname]);

  if (!mountNode) return null;
  return createPortal(<AcademyPathway />, mountNode);
};

export default AcademyPathwayPortal;
